import { InjectionToken } from '@angular/core';

/** Configuration for the subscription subsystem. */
export interface SubscriptionConfig {
  /**
   * Use the offline MOCK repository (localStorage-backed tier machine) instead
   * of the real server-driven subscription API. Independent of other features'
   * flags. Flip to `false` once the real billing/subscription API is wired.
   */
  useMock: boolean;
}

export const DEFAULT_SUBSCRIPTION_CONFIG: SubscriptionConfig = {
  // ← the real `/api/v3/subscription` API. NOTE: there is no longer a silent
  // fallback to a local tier machine — a failed MUTATION surfaces its error and
  // never fabricates premium; only READS fall back, to `SubscriptionStore`'s cache.
  useMock: false,
};

export const SUBSCRIPTION_CONFIG = new InjectionToken<SubscriptionConfig>('SUBSCRIPTION_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_SUBSCRIPTION_CONFIG,
});
